import React from "react";
import { CTAButton, SectionLabel, Reveal } from "../primitives";
import { Section, TCard, BODY } from "../shared";
import vorMauerImg from "@/assets/img/luisa-vor-mauer.jpeg";
import inaImg from "@/assets/img/ina.jpg";

export default function EntscheidungSection() {
  return (
    <Section testId="entscheidung-section" className="py-24 md:py-36">
      <SectionLabel testId="entscheidung-label">So, meine Liebe...</SectionLabel>
      <div className="grid gap-14 md:grid-cols-12 md:items-center">
        <div className="space-y-6 md:col-span-7">
        <Reveal>
          <p className={BODY}>Jetzt ist der Moment gekommen, in dem Du eine Entscheidung treffen darfst.</p>
        </Reveal>
        <Reveal delay={0.05}>
          <p className={BODY}>Wenn Du Dich in dem, was Du hier gelesen hast, wiedergefunden hast, dann hast Du jetzt zwei Optionen:</p>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="border-l-2 border-cognac/40 pl-6">
            <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>1. Nichts tun.</p>
            <p className={BODY}>
              Du kannst alles so lassen, wie es ist. Weiterdenken. Weitergrübeln. Weiterwarten. Entsprechend wird sich auch nichts ändern.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border-l-2 border-cognac-2 pl-6">
            <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>2. Verantwortung übernehmen und für Deinen Traumjob losgehen.</p>
            <p className={BODY}>
              Wenn Du bereit bist, Deine berufliche Zukunft in die Hand zu nehmen, dann ist <strong style={{ fontWeight: 700 }}>Unverschämt Erfolgreich</strong> perfekt für Dich und Deine Reise zu Deinem Traumjob.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.14}>
          <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>
            Du musst noch nicht wissen, wie alles geht.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>
            Du musst nur spüren: Es ist Zeit.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <p className={`${BODY} italic text-cognac-2`}>
            Und wenn Du das hier immer noch liest... wissen wir beide, dass das einen Grund hat.
          </p>
        </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 -z-10 bg-gold" />
              <img
                src={vorMauerImg}
                alt="Luisa Bergholz vor einer alten Mauer"
                width="982"
                height="1403"
                className="w-full object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
      <Reveal delay={0.2}>
        <div className="mt-12">
          <CTAButton variant="cognac" testId="entscheidung-cta-button">Join us</CTAButton>
        </div>
      </Reveal>
      <Reveal delay={0.24}>
        <div className="mt-16 max-w-2xl">
          <TCard
            img={inaImg}
            name="Ina, Unternehmerin"
            lead="Noch nie fühlte ich mich so wertvoll begleitet und empfand mein Geld so gut investiert."
            ps={[
              "Du hast uns gefragt, gebohrt, mit uns Konfetti geschmissen, gelacht und Tränen getrocknet, Anteil genommen, Wege geebnet und uns auf den Pfad der eigenen Stärke geführt. Einen Pfad, den zu erreichen ich für mich in den kühnsten Träumen nicht für möglich erachtet hätte.",
              "Ich weiß, dass ich alles schaffen kann und werde. Danke.",
            ]}
            testId="testimonial-ina"
          />
        </div>
      </Reveal>
    </Section>
  );
}
